import { useAppSelector } from 'app/store';
import { BottomFromTechnicianRoles } from '../../constants';

export function IsBottomFromTechnician({ children }) {
  const groups = useAppSelector((state) => state.auth.groups);
  if (groups?.some((role) => BottomFromTechnicianRoles.includes(role))) return children;
}

export function canViewTechnicianCreatedTickets(): boolean {
  const groups = useAppSelector((state) => state.auth.groups);
  return groups?.some((role) => BottomFromTechnicianRoles.includes(role)) ?? false;
}
